import { render, staticRenderFns } from "./HornorBuyGoodsFlingOrder.vue?vue&type=template&id=d8472aa8&scoped=true&"
import script from "./HornorBuyGoodsFlingOrder.vue?vue&type=script&lang=js&"
export * from "./HornorBuyGoodsFlingOrder.vue?vue&type=script&lang=js&"
import style0 from "./HornorBuyGoodsFlingOrder.vue?vue&type=style&index=0&id=d8472aa8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8472aa8",
  null
  
)

export default component.exports